import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import DateRangeFilter from './DateRangeFilter';
import CreditsUsageChart from './CreditsUsageChart';
import VoiceCreditUsageTable from './VoiceCreditUsageTable';

export default function SubscriptionUsage({
  dateFilter,
  setDateFilter,
  customStart,
  setCustomStart,
  customEnd,
  setCustomEnd,
  usageLoading,
  voiceCreditsBarData,
  userWiseBarData,
  filteredUsageTransactions,
  showUserWisePlaceholder,
  hasVoiceCredits = true,
}) {
  const dateFilterLabel = dateFilter === 'week' ? 'By day (last 7 days)' : dateFilter === 'month' ? 'By day (last 30 days)' : 'By selected date range';

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <DateRangeFilter
        dateFilter={dateFilter}
        setDateFilter={setDateFilter}
        customStart={customStart}
        setCustomStart={setCustomStart}
        customEnd={customEnd}
        setCustomEnd={setCustomEnd}
      />
      {hasVoiceCredits ? (
        <>
          <CreditsUsageChart data={voiceCreditsBarData} loading={usageLoading} dateFilterLabel={dateFilterLabel} />
          <VoiceCreditUsageTable rows={filteredUsageTransactions} loading={usageLoading} />
        </>
      ) : (
        <Paper elevation={0} sx={{ p: 3, borderRadius: 2, border: '1px solid', borderColor: 'divider' }}>
          <Typography variant="body2" color="text.secondary">
            Voice credits and usage details are available on paid plans. Upgrade to view consumption and top-up credits.
          </Typography>
        </Paper>
      )}
    </Box>
  );
}
